import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';

type ValueCardIconMode = 'hidden' | 'routerLink' | 'href' | 'decorative';

@Component({
  selector: 'app-value-card',
  imports: [LucideAngularModule, RouterLink],
  templateUrl: './value-card.html',
  styleUrl: './value-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block h-full',
  },
})
export class ValueCard {
  readonly title = input.required<string>();
  readonly subtitle = input.required<string>();
  readonly text = input.required<string>();
  readonly showIcon = input(true);
  readonly iconHref = input<string | null>(null);
  readonly iconRouterLink = input<string | null>(null);
  readonly iconAriaLabel = input('Open value card destination');

  protected readonly iconMode = computed<ValueCardIconMode>(() => {
    if (!this.showIcon()) {
      return 'hidden';
    }

    if (this.iconRouterLink()) {
      return 'routerLink';
    }

    if (this.iconHref()) {
      return 'href';
    }

    return 'decorative';
  });
}
